// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './permission'
import ElementUI from 'element-ui'
import './theme/index.css'
import Cookies from 'js-cookie'
import i18n from './lang' // internationalization
import store from './store'
import vuescroll from "vuescroll";
import tool from './utils/tool' // js工具初始化
import htmlToPdf from './utils/htmlToPdf' // 页面转pdf下载
import VueLuckyCanvas from '@lucky-canvas/vue' // 抽奖
Vue.use(htmlToPdf)
Vue.use(VueLuckyCanvas)

Vue.prototype.$tool = tool;

Vue.use(vuescroll);
window.axios = require('./axios').default;
window.competitionUrl = "/elearning-competition";
window.courseUrl = "/elearning-course";
window.pubServer = "/pubServer";
window.liveUrl = "/elearning-live";
window.courseCommonUrl = "/common";
window.offlineCourse = "/offline-course";
window.productUrl = "/product";
window.ambassadorUrl = "/elearning-ambassador"
window.awardUrl = "/award"
window.athlete_url = "/athlete-profile"
window.statistic_url = "/statistics"
window.fullTextSearchUrl = "/fulltext-search"

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});

Vue.use(ElementUI);

import { NavBar } from 'vant';

Vue.use(NavBar);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js